// extracted by mini-css-extract-plugin
module.exports =  {"main":"pl__Main-module__main___SHMfv","main__content":"pl__Main-module__main__content___jQTmM"};